import apiClient from '../client';
import type { Signal, CreateSignalRequest, UpdateSignalRequest } from '../types';

export const signalsAPI = {
  /**
   * Get all signals for the authenticated user
   */
  getAll: async (): Promise<Signal[]> => {
    const response = await apiClient.get<Signal[]>('/signals');
    return response.data;
  },

  /**
   * Create a new signal
   * Note: May return array if multiple directions specified
   */
  create: async (data: CreateSignalRequest): Promise<Signal[]> => {
    const response = await apiClient.post<Signal[]>('/signals', data);
    return response.data;
  },

  /**
   * Update an existing signal
   */
  update: async (id: string, data: UpdateSignalRequest): Promise<Signal> => {
    const response = await apiClient.patch<Signal>(`/signals/${id}`, data);
    return response.data;
  },

  /**
   * Delete a signal
   */
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/signals/${id}`);
  },

  /**
   * Toggle signal active status
   * Backend requires: active, isEdit: true, direction
   */
  toggleActive: async (id: string, active: boolean, direction: string): Promise<Signal> => {
    const response = await apiClient.patch<Signal>(`/signals/${id}`, {
      active,
      isEdit: true,
      direction: [direction],
    });
    return response.data;
  },
};
